<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计划名称：</span>
        </div>
        <el-input v-model="planName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计划时段：</span>
        </div>
        <time-interval @getAttendanceItemDurations="getAttendanceItemDurations" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {api} from '../../api/LadderControl'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {pattern} from '../../../utils/regular'
  import TimeInterval from '../../../components/WeekTime/timeInterval'

  export default {
    components: {
      TimeInterval,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'ladder-plant-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧梯控',
          name: 'ladder-device'
        }, {
          value: '设备管理',
        }],
        mainTitle: '添加计划',
        subheading: '',

        planName: '',
        monDetails: [],
        tueDetails: [],
        wedDetails: [],
        thuDetails: [],
        friDetails: [],
        satDetails: [],
        sunDetails: [],
      }
    },
    created () {},
    methods: {
      // 数据整理
      getAttendanceItemDurations(data) {
        this.monDetails = []
        this.tueDetails = []
        this.wedDetails = []
        this.thuDetails = []
        this.friDetails = []
        this.satDetails = []
        this.sunDetails = []
        data.map(v => {
          if (v.weekDay.length > 0) {
            v.weekDay.map(weekDay => {
              if (weekDay === '周一') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.monDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.monDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周二') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.tueDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.tueDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周三') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.wedDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.wedDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周四') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.thuDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.thuDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周五') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.friDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.friDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周六') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.satDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.satDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
              if (weekDay === '周日') {
                v.weekTimeValue.map(weekTimeValue => {
                  let startTime = weekTimeValue.key[0]
                  let endTime = weekTimeValue.key[1]
                  let isInSegments = false
                  this.sunDetails.map(segments => {
                    if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                      isInSegments = true
                    }
                  })
                  if (!isInSegments && startTime && endTime) {
                    this.sunDetails.push({
                      startTime,
                      endTime
                    })
                  }
                })
              }
            })
          }
        })
      },

      // 确认添加
      confirm () {
        if (!this.planName) {
          nError('请输入计划名称')
          return false
        }
        let reqData = {
          planName: this.planName,
          monDetails: this.monDetails,
          tueDetails: this.tueDetails,
          wedDetails: this.wedDetails,
          thuDetails: this.thuDetails,
          friDetails: this.friDetails,
          satDetails: this.satDetails,
          sunDetails: this.sunDetails,
        }
        api.addLiftPlan(reqData)
          .then(() => {
            nSuccess('添加成功')
            this.cancel()
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderPlant/LadderPlantAdd.vue